import { useState, useEffect } from 'react';

export default function HomePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [activeService, setActiveService] = useState(0);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [liveCounter, setLiveCounter] = useState(15247);
  const [currentFollowers, setCurrentFollowers] = useState('');
  const [selectedPackage, setSelectedPackage] = useState(1000);
  const [calculatedGrowth, setCalculatedGrowth] = useState<number | null>(null);
  const [showNotification, setShowNotification] = useState(false);
  const [currentNotification, setCurrentNotification] = useState(0);
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 30
  });

  // Live counter animation
  useEffect(() => {
    const interval = setInterval(() => {
      setLiveCounter(prev => prev + Math.floor(Math.random() * 3));
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // Testimonials carousel auto-play
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial(prev => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const services = [
    {
      icon: "ri-user-follow-line",
      title: "Seguidores Reales",
      description: "Aumenta tu base de seguidores con perfiles auténticos que interactúan con tu contenido",
      platforms: ["Instagram", "TikTok", "YouTube", "Facebook"]
    },
    {
      icon: "ri-heart-fill",
      title: "Likes Reales",
      description: "Impulsa tus publicaciones con likes genuinos que mejoran tu visibilidad",
      platforms: ["Instagram", "TikTok", "Facebook"]
    },
    {
      icon: "ri-eye-line",
      title: "Vistas Reales",
      description: "Aumenta el alcance de tus videos y stories con vistas de cuentas activas",
      platforms: ["Instagram", "TikTok", "YouTube"]
    },
    {
      icon: "ri-chat-3-line",
      title: "Engagement Total",
      description: "Paquetes completos que combinan seguidores, likes y vistas para máximo impacto",
      platforms: ["Todas las plataformas"]
    }
  ];

  const testimonials = [
    {
      name: "María González",
      username: "@mariagonzalez",
      platform: "Instagram",
      image: "https://public.readdy.ai/ai/img_res/592d59c95b6570aaeab036142af18cf9.jpg",
      rating: 5,
      text: "Increíble servicio. En 2 días ya tenía 1000 seguidores nuevos y todos reales. Mi engagement subió un 300%. Totalmente recomendado.",
      followers: "+1.2K seguidores"
    },
    {
      name: "Carlos Méndez",
      username: "@carlosm_fit",
      platform: "TikTok",
      image: "https://readdy.ai/api/search-image?query=athletic%20latino%20man%20confident%20smile%20portrait%20modern%20sporty%20casual%20outfit%20clean%20white%20background%20professional%20lighting&width=100&height=100&seq=test2&orientation=squarish",
      rating: 5,
      text: "Mis videos ahora tienen miles de vistas. El algoritmo me favorece más y estoy llegando a mucha más gente. Excelente inversión.",
      followers: "+3.5K seguidores"
    },
    {
      name: "Ana Rodríguez",
      username: "@anarodriguez",
      platform: "Instagram",
      image: "https://readdy.ai/api/search-image?query=elegant%20latina%20businesswoman%20professional%20smile%20portrait%20modern%20business%20casual%20attire%20clean%20white%20background%20studio%20lighting&width=100&height=100&seq=test3&orientation=squarish",
      rating: 5,
      text: "Pasé de 500 a 5000 seguidores en un mes. Ahora las marcas me contactan para colaboraciones. Cambió mi negocio completamente.",
      followers: "+4.5K seguidores"
    },
    {
      name: "Diego Fernández",
      username: "@diegofernandez",
      platform: "YouTube",
      image: "https://readdy.ai/api/search-image?query=creative%20latino%20content%20creator%20smiling%20confident%20portrait%20casual%20modern%20style%20clean%20white%20background%20natural%20lighting&width=100&height=100&seq=test4&orientation=squarish",
      rating: 5,
      text: "Mis videos tienen más vistas y suscriptores. El servicio es rápido, seguro y los resultados son reales. 100% recomendado.",
      followers: "+2.8K suscriptores"
    },
    {
      name: "Sofía Torres",
      username: "@sofiatorresstyle",
      platform: "Instagram",
      image: "https://readdy.ai/api/search-image?query=stylish%20young%20latina%20fashion%20influencer%20smiling%20portrait%20trendy%20modern%20outfit%20clean%20white%20background%20professional%20lighting&width=100&height=100&seq=test5&orientation=squarish",
      rating: 5,
      text: "Dudaba al principio, pero los resultados hablan por sí solos. Seguidores reales que interactúan. Mi cuenta creció exponencialmente.",
      followers: "+6K seguidores"
    }
  ];

  const guarantees = [
    {
      icon: "ri-shield-check-fill",
      title: "100% Seguro",
      description: "Nunca pedimos tu contraseña. Métodos seguros que cumplen con las políticas de cada plataforma."
    },
    {
      icon: "ri-user-heart-fill",
      title: "Seguidores Reales",
      description: "Todos nuestros seguidores son cuentas reales y activas. Sin bots, sin perfiles falsos."
    },
    {
      icon: "ri-time-fill",
      title: "Entrega Garantizada",
      description: "Si no recibes lo que pediste, te devolvemos tu dinero. Sin preguntas, sin complicaciones."
    },
    {
      icon: "ri-customer-service-fill",
      title: "Soporte 24/7",
      description: "Estamos disponibles todo el día para resolver tus dudas y ayudarte en lo que necesites."
    }
  ];

  const faqs = [
    {
      question: "¿Los seguidores y likes son reales?",
      answer: "Sí, todos nuestros servicios provienen de cuentas reales y activas. No utilizamos bots ni perfiles falsos. Trabajamos con usuarios genuinos que interactúan de forma orgánica."
    },
    {
      question: "¿Necesitan mi contraseña?",
      answer: "No, nunca pedimos tu contraseña. Solo necesitamos el nombre de usuario de tu perfil público. Tu cuenta está 100% segura con nosotros."
    },
    {
      question: "¿Cuánto tarda la entrega?",
      answer: "La entrega comienza inmediatamente después de confirmar tu pedido. Dependiendo del paquete, puede tomar entre 24 a 72 horas para garantizar un crecimiento natural y seguro."
    },
    {
      question: "¿Funciona para cualquier país?",
      answer: "Sí, nuestros servicios funcionan para cuentas de cualquier país. Podemos adaptar la entrega según tu ubicación y audiencia objetivo."
    },
    {
      question: "¿Es seguro para mi cuenta?",
      answer: "Completamente seguro. Utilizamos métodos que cumplen con las políticas de cada plataforma. Miles de clientes confían en nosotros sin ningún problema."
    },
    {
      question: "¿Cómo hago mi pedido?",
      answer: "Es muy simple: escríbenos por Instagram a @despega.uy, cuéntanos qué necesitas, y te enviamos las opciones disponibles. El pago es fácil y seguro."
    }
  ];

  const handleCalculateGrowth = () => {
    const current = parseInt(currentFollowers);
    if (current && current > 0) {
      const newTotal = current + selectedPackage;
      setCalculatedGrowth(newTotal);
    }
  };

  // Social proof notifications
  const notifications = [
    { name: "María", country: "México", package: "1000 seguidores" },
    { name: "Carlos", country: "Argentina", package: "2500 likes" },
    { name: "Ana", country: "Colombia", package: "5000 seguidores" },
    { name: "Diego", country: "Chile", package: "1000 vistas" },
    { name: "Sofía", country: "España", package: "500 seguidores" },
    { name: "Luis", country: "Perú", package: "2500 seguidores" },
    { name: "Valentina", country: "Uruguay", package: "1000 likes" },
    { name: "Mateo", country: "Ecuador", package: "5000 vistas" }
  ];

  // Show notification every 8 seconds
  useEffect(() => {
    const notificationInterval = setInterval(() => {
      setCurrentNotification(prev => (prev + 1) % notifications.length);
      setShowNotification(true);
      setTimeout(() => setShowNotification(false), 5000);
    }, 8000);
    
    // Show first notification after 3 seconds
    setTimeout(() => {
      setShowNotification(true);
      setTimeout(() => setShowNotification(false), 5000);
    }, 3000);

    return () => clearInterval(notificationInterval);
  }, []);

  // Countdown timer
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { hours, minutes, seconds } = prev;
        
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          // Reset timer when it reaches 0
          hours = 2;
          minutes = 45;
          seconds = 30;
        }
        
        return { hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gray-950">
      {/* Social Proof Notification */}
      <div className={`fixed bottom-6 left-6 z-50 transition-all duration-500 ${showNotification ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`}>
        <div className="bg-gray-900 border border-cyan-500/50 rounded-2xl p-4 shadow-2xl shadow-cyan-500/20 backdrop-blur-lg max-w-sm">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full flex items-center justify-center animate-pulse">
              <i className="ri-user-follow-fill text-white text-xl"></i>
            </div>
            <div className="flex-1">
              <p className="text-white font-semibold text-sm">
                {notifications[currentNotification].name} de {notifications[currentNotification].country}
              </p>
              <p className="text-gray-400 text-xs">
                Acaba de comprar <span className="text-cyan-400 font-semibold">{notifications[currentNotification].package}</span>
              </p>
              <div className="flex items-center gap-1 mt-1">
                <div className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse"></div>
                <span className="text-green-400 text-xs font-semibold">Hace 2 minutos</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-gray-950/90 backdrop-blur-lg border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-gradient-to-br from-cyan-400 via-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                <i className="ri-rocket-2-fill text-white text-xl"></i>
              </div>
              <span className="text-2xl font-bold text-white">despega.uy</span>
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <a href="#servicios" className="text-gray-300 hover:text-cyan-400 text-sm font-medium transition-colors cursor-pointer">Servicios</a>
              <a href="#beneficios" className="text-gray-300 hover:text-cyan-400 text-sm font-medium transition-colors cursor-pointer">Beneficios</a>
              <a href="#como-funciona" className="text-gray-300 hover:text-cyan-400 text-sm font-medium transition-colors cursor-pointer">Cómo Funciona</a>
              <a href="#faq" className="text-gray-300 hover:text-cyan-400 text-sm font-medium transition-colors cursor-pointer">FAQ</a>
            </div>
            <a 
              href="https://instagram.com/despega.uy" 
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:shadow-lg hover:shadow-cyan-500/50 transition-all whitespace-nowrap cursor-pointer"
            >
              Escríbenos
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-6 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 via-blue-500/10 to-purple-600/10"></div>
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-72 h-72 bg-cyan-500/20 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-600/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-block bg-gradient-to-r from-cyan-500/20 to-blue-600/20 border border-cyan-500/30 rounded-full px-6 py-2 mb-8">
              <span className="text-cyan-400 text-sm font-semibold">🚀 Crece más rápido en redes sociales</span>
            </div>
            
            <h1 className="text-6xl lg:text-7xl font-extrabold mb-6 leading-tight">
              <span className="text-white">Impulsa tu perfil con</span>
              <br />
              <span className="bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-600 bg-clip-text text-transparent">
                seguidores y engagement reales
              </span>
            </h1>
            
            <p className="text-gray-400 text-xl mb-10 leading-relaxed max-w-3xl mx-auto">
              Acelera el crecimiento de tu cuenta en Instagram, TikTok, YouTube y Facebook. 
              Sin contraseñas, sin riesgos. Solo resultados reales que transforman tu presencia digital.
            </p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
              <a 
                href="https://instagram.com/despega.uy" 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-8 py-4 rounded-full text-lg font-bold hover:shadow-xl hover:shadow-cyan-500/50 transition-all whitespace-nowrap cursor-pointer group"
              >
                <i className="ri-instagram-line text-2xl mr-3"></i>
                Empieza a crecer hoy
                <i className="ri-arrow-right-line ml-3 text-xl group-hover:translate-x-1 transition-transform"></i>
              </a>
              <a 
                href="#como-funciona" 
                className="inline-flex items-center bg-gray-800/50 border border-gray-700 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer"
              >
                Ver cómo funciona
              </a>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-8 text-sm">
              <div className="flex items-center text-gray-400">
                <i className="ri-shield-check-line text-green-400 text-xl mr-2"></i>
                <span>100% Seguro</span>
              </div>
              <div className="flex items-center text-gray-400">
                <i className="ri-time-line text-cyan-400 text-xl mr-2"></i>
                <span>Entrega Rápida</span>
              </div>
              <div className="flex items-center text-gray-400">
                <i className="ri-global-line text-purple-400 text-xl mr-2"></i>
                <span>Cualquier País</span>
              </div>
              <div className="flex items-center text-gray-400">
                <i className="ri-customer-service-2-line text-blue-400 text-xl mr-2"></i>
                <span>Soporte Directo</span>
              </div>
            </div>
          </div>

          {/* Stats with Live Counter */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-20 max-w-5xl mx-auto">
            <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-6 text-center hover:border-cyan-500/50 transition-all">
              <div className="text-4xl font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent mb-2">{liveCounter.toLocaleString()}</div>
              <div className="text-gray-400 text-sm">Clientes Satisfechos</div>
              <div className="flex items-center justify-center mt-2">
                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse mr-2"></div>
                <span className="text-green-400 text-xs font-semibold">En vivo</span>
              </div>
            </div>
            <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-6 text-center hover:border-purple-500/50 transition-all">
              <div className="text-4xl font-bold bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent mb-2">+200K</div>
              <div className="text-gray-400 text-sm">Seguidores Entregados</div>
            </div>
            <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-6 text-center hover:border-blue-500/50 transition-all">
              <div className="text-4xl font-bold bg-gradient-to-r from-blue-400 to-cyan-500 bg-clip-text text-transparent mb-2">4.9★</div>
              <div className="text-gray-400 text-sm">Valoración Promedio</div>
            </div>
            <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-6 text-center hover:border-green-500/50 transition-all">
              <div className="text-4xl font-bold bg-gradient-to-r from-green-400 to-emerald-500 bg-clip-text text-transparent mb-2">24/7</div>
              <div className="text-gray-400 text-sm">Soporte Activo</div>
            </div>
          </div>
        </div>
      </section>

      {/* Limited Time Offer Banner */}
      <section className="py-6 px-6 bg-gradient-to-r from-orange-600 via-red-600 to-pink-600">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center animate-pulse">
                <i className="ri-fire-fill text-white text-2xl"></i>
              </div>
              <div>
                <h3 className="text-white font-bold text-lg">🔥 Oferta Especial - 20% de Descuento</h3>
                <p className="text-white/90 text-sm">En todos los paquetes. ¡Aprovecha antes de que termine!</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <div className="bg-white/20 backdrop-blur-sm rounded-lg px-3 py-2 min-w-[60px] text-center">
                  <div className="text-white font-bold text-2xl">{String(timeLeft.hours).padStart(2, '0')}</div>
                  <div className="text-white/80 text-xs font-semibold">HORAS</div>
                </div>
                <span className="text-white text-2xl font-bold">:</span>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg px-3 py-2 min-w-[60px] text-center">
                  <div className="text-white font-bold text-2xl">{String(timeLeft.minutes).padStart(2, '0')}</div>
                  <div className="text-white/80 text-xs font-semibold">MINUTOS</div>
                </div>
                <span className="text-white text-2xl font-bold">:</span>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg px-3 py-2 min-w-[60px] text-center">
                  <div className="text-white font-bold text-2xl">{String(timeLeft.seconds).padStart(2, '0')}</div>
                  <div className="text-white/80 text-xs font-semibold">SEGUNDOS</div>
                </div>
              </div>
              <a 
                href="https://instagram.com/despega.uy" 
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-red-600 px-6 py-3 rounded-full text-sm font-bold hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer hidden md:inline-flex items-center"
              >
                Aprovechar ahora
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Problem + Solution Section */}
      <section className="py-20 px-6 bg-gray-900/30">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Problem */}
            <div>
              <div className="inline-block bg-red-500/10 border border-red-500/30 rounded-full px-4 py-2 mb-6">
                <span className="text-red-400 text-sm font-semibold">El Problema</span>
              </div>
              <h2 className="text-4xl font-bold text-white mb-6">
                ¿Por qué tu cuenta no crece como esperabas?
              </h2>
              <div className="space-y-4">
                <div className="flex items-start">
                  <i className="ri-close-circle-line text-red-400 text-2xl mr-4 mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-1">Falta de visibilidad inicial</h3>
                    <p className="text-gray-400 text-sm">Los algoritmos favorecen cuentas con engagement. Sin seguidores, tu contenido no se muestra.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-close-circle-line text-red-400 text-2xl mr-4 mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-1">Baja credibilidad</h3>
                    <p className="text-gray-400 text-sm">Los usuarios no confían en perfiles con pocos seguidores o sin interacciones.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-close-circle-line text-red-400 text-2xl mr-4 mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-1">Crecimiento lento</h3>
                    <p className="text-gray-400 text-sm">Crecer orgánicamente puede tomar meses o años sin una base sólida.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Solution */}
            <div>
              <div className="inline-block bg-green-500/10 border border-green-500/30 rounded-full px-4 py-2 mb-6">
                <span className="text-green-400 text-sm font-semibold">La Solución</span>
              </div>
              <h2 className="text-4xl font-bold text-white mb-6">
                Cómo despega.uy acelera tu crecimiento
              </h2>
              <div className="space-y-4">
                <div className="flex items-start">
                  <i className="ri-checkbox-circle-line text-green-400 text-2xl mr-4 mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-1">Impulso inmediato</h3>
                    <p className="text-gray-400 text-sm">Aumentamos tu base de seguidores y engagement para que el algoritmo te favorezca desde el inicio.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-checkbox-circle-line text-green-400 text-2xl mr-4 mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-1">Autoridad instantánea</h3>
                    <p className="text-gray-400 text-sm">Un perfil con más seguidores y likes genera confianza y atrae más usuarios orgánicos.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-checkbox-circle-line text-green-400 text-2xl mr-4 mt-1"></i>
                  <div>
                    <h3 className="text-white font-semibold mb-1">Crecimiento exponencial</h3>
                    <p className="text-gray-400 text-sm">Con una base sólida, tu cuenta crece más rápido de forma natural y sostenible.</p>
                  </div>
                </div>
              </div>
              <a 
                href="https://instagram.com/despega.uy" 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-gradient-to-r from-green-500 to-emerald-600 text-white px-8 py-4 rounded-full text-base font-bold hover:shadow-xl hover:shadow-green-500/50 transition-all whitespace-nowrap cursor-pointer mt-8"
              >
                Impulsa tu perfil ahora
                <i className="ri-arrow-right-up-line ml-2 text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="servicios" className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block bg-gradient-to-r from-cyan-500/20 to-purple-600/20 border border-cyan-500/30 rounded-full px-6 py-2 mb-6">
              <span className="text-cyan-400 text-sm font-semibold">Nuestros Servicios</span>
            </div>
            <h2 className="text-5xl font-bold text-white mb-6">
              Todo lo que necesitas para <span className="bg-gradient-to-r from-cyan-400 to-purple-600 bg-clip-text text-transparent">despegar</span>
            </h2>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto">
              Servicios reales para Instagram, TikTok, YouTube y Facebook. Elige lo que necesitas y empieza a ver resultados.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.map((service, index) => (
              <div 
                key={index}
                className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-8 hover:border-cyan-500/50 hover:shadow-xl hover:shadow-cyan-500/10 transition-all cursor-pointer group"
                onMouseEnter={() => setActiveService(index)}
              >
                <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <i className={`${service.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{service.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed mb-4">
                  {service.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {service.platforms.map((platform, idx) => (
                    <span key={idx} className="text-xs bg-gray-800 text-gray-300 px-3 py-1 rounded-full">
                      {platform}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <a 
              href="https://instagram.com/despega.uy" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-8 py-4 rounded-full text-base font-bold hover:shadow-xl hover:shadow-cyan-500/50 transition-all whitespace-nowrap cursor-pointer"
            >
              Ver todos los paquetes
              <i className="ri-arrow-right-line ml-2 text-xl"></i>
            </a>
          </div>
        </div>
      </section>

      {/* Why We're Different Section */}
      <section className="py-20 px-6 bg-gray-900/30">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block bg-gradient-to-r from-cyan-500/20 to-purple-600/20 border border-cyan-500/30 rounded-full px-6 py-2 mb-6">
              <span className="text-cyan-400 text-sm font-semibold">Comparación</span>
            </div>
            <h2 className="text-5xl font-bold text-white mb-6">
              ¿Por qué elegir <span className="bg-gradient-to-r from-cyan-400 to-purple-600 bg-clip-text text-transparent">despega.uy</span>?
            </h2>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto">
              No todos los servicios son iguales. Mira la diferencia entre despega.uy y otros proveedores.
            </p>
          </div>

          <div className="max-w-5xl mx-auto">
            <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-3xl overflow-hidden">
              {/* Header */}
              <div className="grid grid-cols-3 gap-4 p-6 bg-gray-800/50 border-b border-gray-700">
                <div></div>
                <div className="text-center">
                  <div className="inline-flex items-center justify-center bg-gradient-to-r from-cyan-500 to-blue-600 rounded-full px-6 py-2">
                    <i className="ri-rocket-2-fill text-white mr-2"></i>
                    <span className="text-white font-bold">despega.uy</span>
                  </div>
                </div>
                <div className="text-center">
                  <span className="text-gray-400 font-semibold">Otros servicios</span>
                </div>
              </div>

              {/* Comparison Rows */}
              <div className="divide-y divide-gray-800">
                {/* Row 1 */}
                <div className="grid grid-cols-3 gap-4 p-6 hover:bg-gray-800/30 transition-colors">
                  <div className="flex items-center">
                    <i className="ri-user-heart-fill text-cyan-400 text-xl mr-3"></i>
                    <span className="text-white font-semibold">Seguidores Reales</span>
                  </div>
                  <div className="flex items-center justify-center">
                    <div className="w-10 h-10 bg-green-500/20 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-green-400 text-2xl font-bold"></i>
                    </div>
                  </div>
                  <div className="flex items-center justify-center">
                    <div className="w-10 h-10 bg-red-500/20 rounded-full flex items-center justify-center">
                      <i className="ri-close-line text-red-400 text-2xl font-bold"></i>
                    </div>
                  </div>
                </div>

                {/* Row 2 */}
                <div className="grid grid-cols-3 gap-4 p-6 hover:bg-gray-800/30 transition-colors">
                  <div className="flex items-center">
                    <i className="ri-time-fill text-cyan-400 text-xl mr-3"></i>
                    <span className="text-white font-semibold">Entrega en 24h</span>
                  </div>
                  <div className="flex items-center justify-center">
                    <div className="w-10 h-10 bg-green-500/20 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-green-400 text-2xl font-bold"></i>
                    </div>
                  </div>
                  <div className="flex items-center justify-center">
                    <span className="text-gray-400 text-sm">3-7 días</span>
                  </div>
                </div>

                {/* Row 3 */}
                <div className="grid grid-cols-3 gap-4 p-6 hover:bg-gray-800/30 transition-colors">
                  <div className="flex items-center">
                    <i className="ri-shield-check-fill text-cyan-400 text-xl mr-3"></i>
                    <span className="text-white font-semibold">Sin Contraseña</span>
                  </div>
                  <div className="flex items-center justify-center">
                    <div className="w-10 h-10 bg-green-500/20 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-green-400 text-2xl font-bold"></i>
                    </div>
                  </div>
                  <div className="flex items-center justify-center">
                    <div className="w-10 h-10 bg-red-500/20 rounded-full flex items-center justify-center">
                      <i className="ri-close-line text-red-400 text-2xl font-bold"></i>
                    </div>
                  </div>
                </div>

                {/* Row 4 */}
                <div className="grid grid-cols-3 gap-4 p-6 hover:bg-gray-800/30 transition-colors">
                  <div className="flex items-center">
                    <i className="ri-customer-service-fill text-cyan-400 text-xl mr-3"></i>
                    <span className="text-white font-semibold">Soporte 24/7</span>
                  </div>
                  <div className="flex items-center justify-center">
                    <div className="w-10 h-10 bg-green-500/20 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-green-400 text-2xl font-bold"></i>
                    </div>
                  </div>
                  <div className="flex items-center justify-center">
                    <span className="text-gray-400 text-sm">Limitado</span>
                  </div>
                </div>

                {/* Row 5 */}
                <div className="grid grid-cols-3 gap-4 p-6 hover:bg-gray-800/30 transition-colors">
                  <div className="flex items-center">
                    <i className="ri-refresh-line text-cyan-400 text-xl mr-3"></i>
                    <span className="text-white font-semibold">Garantía de Reemplazo</span>
                  </div>
                  <div className="flex items-center justify-center">
                    <div className="w-10 h-10 bg-green-500/20 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-green-400 text-2xl font-bold"></i>
                    </div>
                  </div>
                  <div className="flex items-center justify-center">
                    <div className="w-10 h-10 bg-red-500/20 rounded-full flex items-center justify-center">
                      <i className="ri-close-line text-red-400 text-2xl font-bold"></i>
                    </div>
                  </div>
                </div>

                {/* Row 6 */}
                <div className="grid grid-cols-3 gap-4 p-6 hover:bg-gray-800/30 transition-colors">
                  <div className="flex items-center">
                    <i className="ri-money-dollar-circle-fill text-cyan-400 text-xl mr-3"></i>
                    <span className="text-white font-semibold">Mejor Precio</span>
                  </div>
                  <div className="flex items-center justify-center">
                    <div className="w-10 h-10 bg-green-500/20 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-green-400 text-2xl font-bold"></i>
                    </div>
                  </div>
                  <div className="flex items-center justify-center">
                    <span className="text-gray-400 text-sm">Más caro</span>
                  </div>
                </div>

                {/* Row 7 */}
                <div className="grid grid-cols-3 gap-4 p-6 hover:bg-gray-800/30 transition-colors">
                  <div className="flex items-center">
                    <i className="ri-global-line text-cyan-400 text-xl mr-3"></i>
                    <span className="text-white font-semibold">Cualquier País</span>
                  </div>
                  <div className="flex items-center justify-center">
                    <div className="w-10 h-10 bg-green-500/20 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-green-400 text-2xl font-bold"></i>
                    </div>
                  </div>
                  <div className="flex items-center justify-center">
                    <span className="text-gray-400 text-sm">Limitado</span>
                  </div>
                </div>

                {/* Row 8 */}
                <div className="grid grid-cols-3 gap-4 p-6 hover:bg-gray-800/30 transition-colors">
                  <div className="flex items-center">
                    <i className="ri-star-fill text-cyan-400 text-xl mr-3"></i>
                    <span className="text-white font-semibold">Calidad Premium</span>
                  </div>
                  <div className="flex items-center justify-center">
                    <div className="w-10 h-10 bg-green-500/20 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-green-400 text-2xl font-bold"></i>
                    </div>
                  </div>
                  <div className="flex items-center justify-center">
                    <span className="text-gray-400 text-sm">Variable</span>
                  </div>
                </div>
              </div>

              {/* CTA Footer */}
              <div className="p-8 bg-gradient-to-r from-cyan-500/10 to-purple-600/10 border-t border-cyan-500/30 text-center">
                <p className="text-white text-lg font-semibold mb-4">
                  La diferencia es clara. Elige calidad, velocidad y seguridad.
                </p>
                <a 
                  href="https://instagram.com/despega.uy" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-8 py-4 rounded-full text-base font-bold hover:shadow-xl hover:shadow-cyan-500/50 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-instagram-line text-xl mr-2"></i>
                  Empieza con despega.uy
                  <i className="ri-arrow-right-line ml-2 text-xl"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Carousel Section */}
      <section className="py-20 px-6 bg-gray-900/30">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block bg-gradient-to-r from-yellow-500/20 to-orange-600/20 border border-yellow-500/30 rounded-full px-6 py-2 mb-6">
              <span className="text-yellow-400 text-sm font-semibold">Testimonios Reales</span>
            </div>
            <h2 className="text-5xl font-bold text-white mb-6">
              Lo que dicen nuestros <span className="bg-gradient-to-r from-cyan-400 to-purple-600 bg-clip-text text-transparent">clientes</span>
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              Miles de personas ya están creciendo con despega.uy. Lee sus experiencias reales.
            </p>
          </div>

          <div className="relative max-w-4xl mx-auto">
            <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-3xl p-8 md:p-12">
              <div className="flex flex-col md:flex-row items-center gap-8">
                <div className="w-24 h-24 flex-shrink-0">
                  <img 
                    src={testimonials[currentTestimonial].image} 
                    alt={testimonials[currentTestimonial].name}
                    className="w-full h-full rounded-full object-cover border-4 border-cyan-500/30"
                  />
                </div>
                
                <div className="flex-1 text-center md:text-left">
                  <div className="flex items-center justify-center md:justify-start gap-1 mb-3">
                    {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                    ))}
                  </div>
                  
                  <p className="text-gray-300 text-lg leading-relaxed mb-6 italic">
                    "{testimonials[currentTestimonial].text}"
                  </p>
                  
                  <div className="flex items-center justify-center md:justify-start gap-4">
                    <div>
                      <h4 className="text-white font-bold text-lg">{testimonials[currentTestimonial].name}</h4>
                      <p className="text-cyan-400 text-sm">{testimonials[currentTestimonial].username}</p>
                    </div>
                    <div className="h-8 w-px bg-gray-700"></div>
                    <div className="bg-gradient-to-r from-green-500/20 to-emerald-600/20 border border-green-500/30 rounded-full px-4 py-1">
                      <span className="text-green-400 text-sm font-semibold">{testimonials[currentTestimonial].followers}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Navigation Dots */}
            <div className="flex items-center justify-center gap-3 mt-8">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestimonial(index)}
                  className={`transition-all cursor-pointer ${
                    currentTestimonial === index 
                      ? 'w-8 h-3 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-full' 
                      : 'w-3 h-3 bg-gray-700 rounded-full hover:bg-gray-600'
                  }`}
                  aria-label={`Ver testimonio ${index + 1}`}
                ></button>
              ))}
            </div>

            {/* Navigation Arrows */}
            <button
              onClick={() => setCurrentTestimonial(prev => prev === 0 ? testimonials.length - 1 : prev - 1)}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 bg-gray-800 hover:bg-gray-700 border border-gray-700 rounded-full flex items-center justify-center transition-all cursor-pointer"
              aria-label="Testimonio anterior"
            >
              <i className="ri-arrow-left-s-line text-white text-2xl"></i>
            </button>
            <button
              onClick={() => setCurrentTestimonial(prev => (prev + 1) % testimonials.length)}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 bg-gray-800 hover:bg-gray-700 border border-gray-700 rounded-full flex items-center justify-center transition-all cursor-pointer"
              aria-label="Siguiente testimonio"
            >
              <i className="ri-arrow-right-s-line text-white text-2xl"></i>
            </button>
          </div>
        </div>
      </section>

      {/* Guarantees Section */}
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block bg-gradient-to-r from-green-500/20 to-emerald-600/20 border border-green-500/30 rounded-full px-6 py-2 mb-6">
              <span className="text-green-400 text-sm font-semibold">Nuestras Garantías</span>
            </div>
            <h2 className="text-5xl font-bold text-white mb-6">
              Tu tranquilidad es nuestra <span className="bg-gradient-to-r from-cyan-400 to-purple-600 bg-clip-text text-transparent">prioridad</span>
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              Trabajamos con total transparencia y compromiso. Estas son nuestras garantías.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {guarantees.map((guarantee, index) => (
              <div 
                key={index}
                className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-8 hover:border-green-500/50 hover:shadow-xl hover:shadow-green-500/10 transition-all text-center"
              >
                <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className={`${guarantee.icon} text-white text-4xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{guarantee.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  {guarantee.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Growth Calculator Section */}
      <section className="py-20 px-6 bg-gray-900/30">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-block bg-gradient-to-r from-purple-500/20 to-pink-600/20 border border-purple-500/30 rounded-full px-6 py-2 mb-6">
              <span className="text-purple-400 text-sm font-semibold">Calculadora de Crecimiento</span>
            </div>
            <h2 className="text-5xl font-bold text-white mb-6">
              Calcula tu <span className="bg-gradient-to-r from-cyan-400 to-purple-600 bg-clip-text text-transparent">crecimiento</span>
            </h2>
            <p className="text-gray-400 text-lg">
              Descubre cuántos seguidores tendrás después de usar nuestros servicios
            </p>
          </div>

          <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-3xl p-8 md:p-12">
            <div className="space-y-8">
              {/* Current Followers Input */}
              <div>
                <label className="block text-white font-semibold mb-3 text-lg">
                  ¿Cuántos seguidores tienes actualmente?
                </label>
                <input
                  type="number"
                  value={currentFollowers}
                  onChange={(e) => setCurrentFollowers(e.target.value)}
                  placeholder="Ej: 500"
                  className="w-full bg-gray-800 border border-gray-700 rounded-xl px-6 py-4 text-white text-lg focus:outline-none focus:border-cyan-500 transition-colors"
                />
              </div>

              {/* Package Selection */}
              <div>
                <label className="block text-white font-semibold mb-3 text-lg">
                  Elige tu paquete de seguidores
                </label>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  {[500, 1000, 2500, 5000].map((amount) => (
                    <button
                      key={amount}
                      onClick={() => setSelectedPackage(amount)}
                      className={`py-4 px-6 rounded-xl font-bold text-lg transition-all cursor-pointer ${
                        selectedPackage === amount
                          ? 'bg-gradient-to-r from-cyan-500 to-blue-600 text-white shadow-lg shadow-cyan-500/30'
                          : 'bg-gray-800 text-gray-300 hover:bg-gray-700 border border-gray-700'
                      }`}
                    >
                      +{amount.toLocaleString()}
                    </button>
                  ))}
                </div>
              </div>

              {/* Calculate Button */}
              <button
                onClick={handleCalculateGrowth}
                className="w-full bg-gradient-to-r from-purple-500 to-pink-600 text-white py-5 rounded-xl text-lg font-bold hover:shadow-xl hover:shadow-purple-500/50 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calculator-line mr-2 text-xl"></i>
                Calcular mi crecimiento
              </button>

              {/* Result */}
              {calculatedGrowth !== null && (
                <div className="bg-gradient-to-r from-cyan-500/10 to-purple-600/10 border border-cyan-500/30 rounded-2xl p-8 text-center animate-fadeIn">
                  <p className="text-gray-300 text-lg mb-4">Tu nuevo total de seguidores será:</p>
                  <div className="text-6xl font-extrabold bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-600 bg-clip-text text-transparent mb-4">
                    {calculatedGrowth.toLocaleString()}
                  </div>
                  <p className="text-gray-400 mb-6">
                    Un crecimiento de <strong className="text-green-400">+{selectedPackage.toLocaleString()} seguidores</strong>
                  </p>
                  <a 
                    href="https://instagram.com/despega.uy" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-8 py-4 rounded-full text-base font-bold hover:shadow-xl hover:shadow-cyan-500/50 transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-instagram-line text-xl mr-2"></i>
                    Hacer mi pedido ahora
                    <i className="ri-arrow-right-line ml-2 text-xl"></i>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section id="beneficios" className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-white mb-6">
              ¿Por qué elegir <span className="bg-gradient-to-r from-cyan-400 to-purple-600 bg-clip-text text-transparent">despega.uy</span>?
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              No somos como los demás. Estos son los beneficios que nos hacen diferentes.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-flashlight-fill text-white text-4xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Entrega Rápida</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Comenzamos a entregar en menos de 24 horas. No esperas semanas, ves resultados de inmediato.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-lock-password-line text-white text-4xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Sin Contraseña</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Nunca pedimos tu contraseña. Solo necesitamos tu usuario. Tu cuenta está 100% segura.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-earth-fill text-white text-4xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Para Cualquier País</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                No importa dónde estés. Nuestros servicios funcionan en todo el mundo sin restricciones.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-customer-service-2-fill text-white text-4xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Soporte Directo</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Hablamos contigo por Instagram. Respuestas rápidas, atención personalizada, sin bots.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="como-funciona" className="py-20 px-6 bg-gray-900/30">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block bg-gradient-to-r from-cyan-500/20 to-purple-600/20 border border-cyan-500/30 rounded-full px-6 py-2 mb-6">
              <span className="text-cyan-400 text-sm font-semibold">Proceso Simple</span>
            </div>
            <h2 className="text-5xl font-bold text-white mb-6">
              Cómo funciona en <span className="bg-gradient-to-r from-cyan-400 to-purple-600 bg-clip-text text-transparent">3 pasos</span>
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              Es tan fácil que puedes empezar ahora mismo. Sin complicaciones, sin esperas.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {/* Step 1 */}
            <div className="relative">
              <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-8 hover:border-cyan-500/50 transition-all">
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-xl flex items-center justify-center text-white font-bold text-xl">
                  1
                </div>
                <div className="w-16 h-16 bg-gradient-to-br from-cyan-500/20 to-blue-600/20 rounded-xl flex items-center justify-center mb-6 mt-4">
                  <i className="ri-shopping-cart-line text-cyan-400 text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4">Elige tu paquete</h3>
                <p className="text-gray-400 leading-relaxed">
                  Escríbenos a <strong className="text-cyan-400">@despega.uy</strong> en Instagram y cuéntanos qué necesitas: seguidores, likes, vistas o un paquete completo.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="relative">
              <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-8 hover:border-purple-500/50 transition-all">
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-600 rounded-xl flex items-center justify-center text-white font-bold text-xl">
                  2
                </div>
                <div className="w-16 h-16 bg-gradient-to-br from-purple-500/20 to-pink-600/20 rounded-xl flex items-center justify-center mb-6 mt-4">
                  <i className="ri-secure-payment-line text-purple-400 text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4">Realiza el pedido</h3>
                <p className="text-gray-400 leading-relaxed">
                  Te enviamos las opciones disponibles y los precios. Eliges el que más te convenga y realizas el pago de forma fácil y segura.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="relative">
              <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-8 hover:border-green-500/50 transition-all">
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center text-white font-bold text-xl">
                  3
                </div>
                <div className="w-16 h-16 bg-gradient-to-br from-green-500/20 to-emerald-600/20 rounded-xl flex items-center justify-center mb-6 mt-4">
                  <i className="ri-rocket-2-fill text-green-400 text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4">Empieza a ver resultados</h3>
                <p className="text-gray-400 leading-relaxed">
                  En menos de 24 horas comenzamos la entrega. Verás cómo tu perfil crece de forma natural y segura.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <a 
              href="https://instagram.com/despega.uy" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-10 py-5 rounded-full text-xl font-bold hover:shadow-2xl hover:shadow-cyan-500/50 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-instagram-line text-2xl mr-3"></i>
              Empezar ahora en Instagram
              <i className="ri-arrow-right-line ml-3 text-xl"></i>
            </a>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-20 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-white mb-6">
              Preguntas <span className="bg-gradient-to-r from-cyan-400 to-purple-600 bg-clip-text text-transparent">Frecuentes</span>
            </h2>
            <p className="text-gray-400 text-lg">
              Resolvemos tus dudas antes de que empieces
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl hover:border-cyan-500/50 transition-all overflow-hidden"
              >
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer"
                >
                  <span className="text-lg font-bold text-white pr-4">{faq.question}</span>
                  <i className={`${openFaq === index ? 'ri-subtract-line' : 'ri-add-line'} text-2xl text-cyan-400 flex-shrink-0`}></i>
                </button>
                {openFaq === index && (
                  <div className="px-8 pb-6">
                    <p className="text-gray-400 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="relative py-32 px-6 overflow-hidden bg-gray-900/30">
        <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/20 via-blue-500/20 to-purple-600/20"></div>
        <div className="absolute inset-0">
          <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-500/30 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-600/30 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>
        
        <div className="relative max-w-5xl mx-auto text-center">
          <div className="inline-block bg-gradient-to-r from-yellow-500/20 to-orange-600/20 border border-yellow-500/30 rounded-full px-6 py-2 mb-8">
            <span className="text-yellow-400 text-sm font-semibold">⚡ Última oportunidad</span>
          </div>
          
          <h2 className="text-6xl lg:text-7xl font-extrabold text-white mb-6 leading-tight">
            No esperes más.<br />
            <span className="bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-600 bg-clip-text text-transparent">
              Despega hoy mismo.
            </span>
          </h2>
          
          <p className="text-gray-300 text-xl mb-12 leading-relaxed max-w-3xl mx-auto">
            Miles de personas ya están creciendo con nosotros. Es tu turno de transformar tu presencia digital y alcanzar tus metas en redes sociales.
          </p>
          
          <a 
            href="https://instagram.com/despega.uy" 
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-gradient-to-r from-cyan-500 via-blue-600 to-purple-600 text-white px-12 py-6 rounded-full text-xl font-bold hover:shadow-2xl hover:shadow-cyan-500/50 transition-all whitespace-nowrap cursor-pointer group mb-8"
          >
            <i className="ri-instagram-line text-3xl mr-4"></i>
            Escríbenos ahora en Instagram
            <i className="ri-arrow-right-line ml-4 text-2xl group-hover:translate-x-2 transition-transform"></i>
          </a>

          <p className="text-gray-400 text-sm">
            📱 Respuesta inmediata • 🔒 100% Seguro • 🚀 Resultados garantizados
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-950 border-t border-gray-800 py-12 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            {/* Brand */}
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-cyan-400 via-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                  <i className="ri-rocket-2-fill text-white text-xl"></i>
                </div>
                <span className="text-2xl font-bold text-white">despega.uy</span>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed mb-4">
                Impulsamos tu presencia digital con seguidores, likes y engagement reales para Instagram, TikTok, YouTube y Facebook.
              </p>
              <a 
                href="https://instagram.com/despega.uy" 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl mr-2"></i>
                <span className="font-semibold">@despega.uy</span>
              </a>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-white font-bold mb-4">Enlaces Rápidos</h4>
              <ul className="space-y-3">
                <li>
                  <a href="#servicios" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                    Servicios
                  </a>
                </li>
                <li>
                  <a href="#beneficios" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                    Beneficios
                  </a>
                </li>
                <li>
                  <a href="#como-funciona" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                    Cómo Funciona
                  </a>
                </li>
                <li>
                  <a href="#faq" className="text-gray-400 hover:text-cyan-400 transition-colors text-sm cursor-pointer">
                    Preguntas Frecuentes
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-white font-bold mb-4">Contacto</h4>
              <p className="text-gray-400 text-sm mb-4">
                ¿Listo para crecer? Escríbenos directamente por Instagram y te respondemos al instante.
              </p>
              <a 
                href="https://instagram.com/despega.uy" 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-6 py-3 rounded-full text-sm font-semibold hover:shadow-lg hover:shadow-cyan-500/50 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-instagram-line text-lg mr-2"></i>
                Contactar ahora
              </a>
            </div>
          </div>

          {/* Bottom */}
          <div className="border-t border-gray-800 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-500 text-sm mb-4 md:mb-0">
                © 2024 despega.uy - Todos los derechos reservados
              </p>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-cyan-400 text-sm transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
